<template>
  <div class="fotoportada-container" ref="containerRef">
    <!-- Sobre y tarjeta -->
    <div class="contenedor-sobre-tarjeta" ref="sobreRef">
      <img src="@/assets/M (2).png" alt="Sobre decorativo" class="imagen-sobre" />

      <div class="tarjeta-decorativa" ref="tarjetaRef">
        <img src="@/assets/sello.avif" alt="Sello" class="sello-tarjeta" />
        <div class="nombres-tarjeta">
          <div class="fecha-tarjeta" ref="textoRef">
            <span class="dia">30</span><br />
            <span class="mes">Diciembre</span><br />
            <span class="año">2026</span><br />
            <span class="nombres-titulo">Marisa y Martin</span><br />
            Tenemos el gusto de invitarte  <br />a celebrar nuestro aniversario de 30 Años de matrimonio ante Dios  <br />y queremos celebrarlo junto a tí.
          </div>
        </div>
      </div>
    </div>

    <!-- Fondo -->
    <img :src="require('@/assets/7.png')" alt="Fondo textura" class="fondo-textura" />

    <!-- FOTO DE LA PAREJA -->


  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'PortadaInvitacion-v',
  setup() {
    const containerRef = ref(null)
    const sobreRef = ref(null)
    const tarjetaRef = ref(null)
    const textoRef = ref(null)
    const fotoRef = ref(null)
    const selloImagenRef = ref(null)

    onMounted(() => {
      // Reducido el umbral a 0.1 para que la animación inicie inmediatamente al asomarse en pantalla
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Se optimizan las duraciones y se eliminan los retardos (delays) entre elementos
            gsap.timeline()
              .fromTo(
                sobreRef.value,
                { x: -150, opacity: 0 },
                { x: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }
              )
              .fromTo(
                tarjetaRef.value,
                { opacity: 0, y: 15 },
                { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' },
                '-=0.4' // Se solapa sutilmente para acelerar el ritmo visual
              )
              .fromTo(
                textoRef.value,
                { opacity: 0, scale: 0.9 },
                { opacity: 1, scale: 1, duration: 0.9, ease: 'back.out(1.4)' },
                '-=0.3'
              );

            obs.unobserve(entry.target)
          }
        })
      }, { threshold: 0.1 })

      observer.observe(containerRef.value)

      // Movimiento vertical del sello cuando entra al viewport
      gsap.to(selloImagenRef.value, {
        y: -180,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: selloImagenRef.value,
          start: 'top 95%', // Empieza casi de inmediato al tocar la zona inferior
          end: 'top 40%',
          scrub: 0.2
        }
      })

      // Rotación suave mientras haces scroll
      gsap.to(selloImagenRef.value, {
        rotation: -5,
        scrollTrigger: {
          trigger: selloImagenRef.value,
          start: 'top 95%',
          end: 'top 40%',
          scrub: 0.3
        }
      })

      // Foto portada animada con ScrollTrigger acelerado
      gsap.from(fotoRef.value, {
        scrollTrigger: {
          trigger: fotoRef.value,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
        opacity: 0,
        y: 60,
        scale: 0.95,
        duration: 1.2,
        ease: 'power3.out'
      })
    })

    return {
      containerRef,
      sobreRef,
      tarjetaRef,
      textoRef,
      fotoRef,
      selloImagenRef
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  top: -60px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  overflow: hidden;
  margin-bottom: -60px;
  
  /* AGREGA ESTAS 4 LÍNEAS ABAJO */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.fondo-textura {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.sello-contenedor {
  display: flex;
  justify-content: center;
  margin-top: 0px;
  z-index: 2;
}

.contenedor-foto {
  display: flex;
  justify-content: center;
  margin-top: 750px;
  z-index: 2;
  margin-bottom: -90px;
  position: relative;
}

.sello-imagen {
  width: 100px;
  height: auto;
  z-index: 10;
  opacity: 1;
  position: relative;
}

.foto-pareja {
  position: relative;
  display: block;
  width: 100%;
  max-width: 340px;
  margin: 40px auto 0;
  border-radius: 10px;
  z-index: 2;
}

.contenedor-sobre-tarjeta {
  position: relative; /* <-- Cambia 'absolute' por 'relative' */
  width: 100%;
  max-width: 420px;
  height: 800px;       /* <-- Agrega este alto fijo */
  margin-top: 40px;    /* <-- Agrega este margen superior */
  z-index: 4;
  display: flex;
  align-items: flex-start;
}

.imagen-sobre {
  width: 380px;
  height: auto;
  margin-top: 20px;
  margin-left: -15px;
  z-index: 1;
}

.tarjeta-decorativa {
  background-color: #817b76;
  color: white;
  padding: 90px 20px 30px;
  border-radius: 0 30px 30px 0;
  font-family: 'say2';
  font-size: 14px;
  overflow: visible;
  text-align: center;
  position: absolute;
  top: 320px;
  left: 85px;
  z-index: 3;
  width: 320px;
  min-height: 460px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: 80px;
}

.sello-tarjeta {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  z-index: 14;
}@media (max-width: 420px) {
  .contenedor-sobre-tarjeta {
    /* Reduce el tamaño de todo el contenedor al 92% de su tamaño original */
    transform: scale(0.92); 
    /* Le dice que se encoja tomando como eje el centro superior */
    transform-origin: top center; 
    /* Le da un margen superior para que no choque con el borde del celular */
    margin-top: 20px; 
  }
}

@media (max-width: 375px) {
  .contenedor-sobre-tarjeta {
    /* En celulares aún más chicos (como iPhones antiguos), lo encoge al 85% */
    transform: scale(0.85); 
    margin-top: 10px;
  }
}

.nombres-tarjeta {
  margin-top: 10px;
  line-height: 1.3;
}

.fecha-tarjeta {
  font-family: 'padres';
  font-size: 18px;
  color: #d8d8b6;
  margin-top: -40px;
  margin-bottom: -40px;
}

.fecha-tarjeta .dia {
  font-size: 18px;
  font-weight: bold;
}

.fecha-tarjeta .mes {
  font-size: 16px;
  font-style: italic;
}

.fecha-tarjeta .año {
  font-size: 12px;
}

.nombres-titulo {
  font-family: 'Corinthia', cursive;
  font-size: 47px;
  color: #ffffff;
  line-height: 2.9;
  margin-top: 10px;
}
</style>